/* eslint-disable i18next/no-literal-string */
import { memoizeFunction } from '@fluentui/react';
import { IAppTheme } from 'common/theme';

export const getStyles = memoizeFunction(({ palette, appColors, effects }: IAppTheme) => ({
  button: {
    root: {
      backgroundColor: appColors?.white100ToAnchor20,
      borderRadius: '100%',
      flexShrink: '0 !important',
    },
    rootFocused: {
      border: `2px solid ${palette.themeDark} !important`,
      '&:after': {
        outline: 'none !important',
      },
    },
    rootHovered: {
      boxShadow: effects.elevation8,
    },
  },
}));
